import Config from '../internal/common/config';
import { DEFAULT_OBSERVABILITY_CONFIG } from '../internal/constants';
// Stores the `initObservability` config which is used by imperative methods
// of @sail/observability. Delete once we move to a declarative initialization.
export default new Config(DEFAULT_OBSERVABILITY_CONFIG);

//# sourceMappingURL=config.js.map